import _capitalize from "lodash/capitalize";
import "core-js/modules/es.array.map.js";
import classnames from 'classnames';
import { Image } from "../../Image/Image/Image";
import { Text } from "../../Text/Text/Text";
import { Breakpoint } from "../../Responsive/Breakpoint/Breakpoint";
import styles from "./ImageSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ImageSlice = function ImageSlice(_ref) {
  var caption = _ref.caption,
    headline = _ref.headline,
    images = _ref.images,
    _ref$marginVariant = _ref.marginVariant,
    marginVariant = _ref$marginVariant === void 0 ? 'normalMargin' : _ref$marginVariant;
  return /*#__PURE__*/_jsxs("figure", {
    className: classnames({
      [styles.wrapper]: true,
      [styles.multiple]: images && images.length > 1
    }),
    children: [marginVariant === 'noMargin' && !headline ? null : /*#__PURE__*/_jsx(Text, {
      className: styles.headline,
      typog: "headline5",
      children: headline
    }), /*#__PURE__*/_jsx("div", {
      className: classnames(styles.images, {
        [styles[marginVariant]]: marginVariant === 'noMargin'
      }),
      children: images === null || images === void 0 ? void 0 : images.map(function (image, key) {
        var _image$desktop, _image$desktop2, _image$mobile, _image$mobile2;
        var hasWidth = image === null || image === void 0 ? void 0 : (_image$desktop = image.desktop) === null || _image$desktop === void 0 ? void 0 : _image$desktop.width;
        var hasAlign = image === null || image === void 0 ? void 0 : (_image$desktop2 = image.desktop) === null || _image$desktop2 === void 0 ? void 0 : _image$desktop2.align;
        return /*#__PURE__*/_jsx("div", {
          className: styles.imageWrapper,
          children: /*#__PURE__*/_jsxs(Breakpoint, {
            breakpoint: "large",
            children: [/*#__PURE__*/_jsx(Image, {
              className: classnames(styles.image, styles.imageMobile),
              src: (_image$mobile = image.mobile) !== null && _image$mobile !== void 0 && _image$mobile.image1x ? image.mobile.image1x : image.desktop.image1x,
              srcTwoX: (_image$mobile2 = image.mobile) === null || _image$mobile2 === void 0 ? void 0 : _image$mobile2.image2x,
              alt: image.alt,
              loading: image.loading || 'lazy'
            }), /*#__PURE__*/_jsx("div", {
              className: classnames({
                [styles["alignImage".concat(_capitalize(image.desktop.align))]]: hasAlign
              }),
              children: /*#__PURE__*/_jsx(Image, {
                className: classnames(styles.image, {
                  [styles.imageFullWidth]: !hasWidth
                }),
                src: image.desktop.image1x,
                srcTwoX: image.desktop.image2x,
                alt: image.alt,
                width: image.desktop.width,
                loading: image.loading || 'lazy'
              })
            })]
          })
        }, key);
      })
    }), marginVariant === 'noMargin' && !caption ? null : /*#__PURE__*/_jsx("figcaption", {
      className: styles.caption,
      children: /*#__PURE__*/_jsx(Text, {
        typog: "captionSmall",
        children: caption
      })
    })]
  });
};